<div class="recent-searches" [avanoLoadingIndicator]="blockingIndicator">
  <span class="recent-searches-header">{{ translationKeys.recentSearches.component.heading | translate }}</span>

  <div *ngIf="loading; else callFinished" class="searches-loading-placeholder"></div>
  <ng-template #callFinished>
    <div *ngIf="!tempRecentSearchList?.length" class="no-searches">
      <span
        >{{ translationKeys.recentSearches.component.noSearches.substringOne | translate }}<br />
        {{ translationKeys.recentSearches.component.noSearches.substringTwo | translate }}</span
      >
    </div>

    <div *ngIf="tempRecentSearchList.length">
      <input
        type="text"
        class="filter"
        [(ngModel)]="currentSearchTerm"
        avanoInputText
        placeholder="{{ translationKeys.recentSearches.component.filter | translate }}"
        (ngModelChange)="filterRecentSearches()"
      />
      <avano-divider class='divider-top'></avano-divider>
      <div class="recent-searches-container avano-scrollbars">
        <div *ngIf="!recentSearchList.length" class="no-searches">
          <span>{{ translationKeys.recentSearches.component.noFilterMatches | translate }}</span>
        </div>
        <div *ngFor="let entry of recentSearchList">
          <div class="entry">
            <div class="entry-text-container" (click)="clickRecentSearch(entry)">
              <i class="icon-content-search"></i>
              <div class="entry-text" [pTooltip]="entry.savedHtml" scipSpacesAsIs>{{ entry.text }}</div>
            </div>
          </div>
          <div class="entry-spacer"></div>
        </div>
      </div>
      <avano-divider class='divider-bottom'></avano-divider>
    </div>
  </ng-template>
</div>
